import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { User } from '../../types/schema';


interface DeleteUserModalProps {
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  user: User | null;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ open, onClose, onConfirmDelete, user }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2">
          Delete User
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Are you sure you want to delete the user "{user?.full_name}"? This action cannot be undone.
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onConfirmDelete} variant="contained" color="error" sx={{ ml: 1 }}>Delete</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteUserModal;
